export const appVersion = require('../../package.json').version;
